<template>
  <div v-if="validatedDay">
    <b-tooltip
      v-if="validatedDay.value"
      position="is-top"
      class="tooltip-header"
    >
      <div v-if="validatedDay.value" :style="validatedDay.style">
        <span tabindex="0" class="warning" v-if="validatedDay.icon === 'exclamation'">
          <i data-icon="exclamation" class="icon icon-warning"></i>
        </span>
        {{ day.weekDayName }} <br />
        {{ day.day }}
      </div>

      <template v-slot:content>
        {{ validatedDay.value }}
      </template>
    </b-tooltip>
    <div v-if="!validatedDay.value && day" :style="validatedDay.style">
      {{ day.weekDayName }} <br />
      {{ day.day }}
    </div>
  </div>
</template>

<script>
export default {
  name: "ScheduleDayHeader",
  props: {
    day: {
      type: Object,
    },
    overAllocations: {
      type: Array,
    },
  },
  data: () => ({
    validatedDay: {style: {background: 'white'}},
  }),
  methods: {
    mounted() {
      const dateString = this.day.date.format("YYYY-MM-DD");
      if (
        !this.overAllocations ||
        !this.overAllocations.find((o) => o.key === dateString)
      ) {
        this.validatedDay = null;
      }
      const overAllocation = this.overAllocations.find(
        (o) => o.key === dateString
      );
      if(overAllocation !== undefined){
        this.validatedDay = {
        value: overAllocation.value,
        style: overAllocation.styles,
        icon: overAllocation.icon
      };
      this.validatedDay =  {style: {background: 'white'}}
      }
      
    },
  },
  watch: {
    day(newValue) {
      
      const dateString = newValue.date.format("YYYY-MM-DD");
      if (
        !this.overAllocations ||
        !this.overAllocations.find((o) => o.key === dateString)
      ) {
        this.validatedDay = null;
      }
      const overAllocation = this.overAllocations.find(
        (o) => o.key === dateString
      );
      if(overAllocation !== undefined){
        this.validatedDay = {
        value: overAllocation.value,
        style: overAllocation.styles,
        icon: overAllocation.icon
      };
      }
      this.validatedDay =  {style: {background: 'white'}}
    },
    overAllocations(newValue) {
      const dateString = this.day.date.format("YYYY-MM-DD");
      if (!newValue || !newValue.find((o) => o.key === dateString)) {
        this.validatedDay = null;
      }
      const overAllocation = newValue.find((o) => o.key === dateString);
      
      this.validatedDay = {
        value: overAllocation.value,
        style: overAllocation.styles,
        icon: overAllocation.icon
      };
    },
  },
};
</script>
<style lang="scss">
.tooltip-header {
  width: 100%;
  height: 100%;
}
.tooltip-content {
  margin-bottom: -15px
}
</style>
